import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "./pages/Landing";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Membership from "./pages/Membership";
import MemberDashboard from "./pages/MemberDashboard";
import MemberBillingSuccess from "./pages/MemberBillingSuccess";
import MemberLogin from "./pages/MemberLogin";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import MemberActivate from "./pages/MemberActivate";
import { Toaster } from "sonner";

function RequireAdmin({ children }) {
  const token = localStorage.getItem("gt_token");
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
}

function RequireMember({ children }) {
  const token = localStorage.getItem("gt_member_token");
  if (!token) return <Navigate to="/membership" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/member/login" element={<MemberLogin />} />
          <Route path="/member/forgot-password" element={<ForgotPassword />} />
          <Route path="/member/reset-password" element={<ResetPassword />} />
          <Route path="/member/activate" element={<MemberActivate />} />
          <Route path="/member/billing/success" element={<RequireMember><MemberBillingSuccess /></RequireMember>} />
          <Route path="/member/dashboard" element={<RequireMember><MemberDashboard /></RequireMember>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminDashboard />
              </RequireAdmin>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#141414",
            border: "1px solid #27272A",
            color: "#FFFFFF",
            borderRadius: 0,
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
